// extracted by mini-css-extract-plugin
module.exports =  {"Label":"WbUfcm_bx4nAlLDlcf7q"};